import { useContext } from "react";

import type { OfficeContextType } from "./office-context.js";
import { OfficeContext } from "./office-context.js";

export const useOffice = (): OfficeContextType => {
  const context = useContext(OfficeContext);

  if (!context) {
    throw new Error("useOffice has to be used inside OfficeThemeProvider");
  }

  return context;
};
